/** Normalize EMS list/mode responses into a flat array of row objects. */
export function extractRowsFromResponse(result) {
  if (!result) return [];
  if (Array.isArray(result)) return result;

  const candidates = [
    result?.data?.data,
    result?.data?.rows,
    result?.data,
    result?.rows,
    result?.entity,
    result?.Departments,
    result?.departments,
    result?.Locations,
    result?.locations,
    result?.Designations,
    result?.designations,
    result?.Workshifts,
    result?.workshifts,
    result?.Users,
    result?.users,
    result?.UserRoles,
    result?.userroles,
    result?.Employees,
    result?.employees,
    result?.EmployeeExits,
    result?.employee_exits,
    result?.recruitment_sources,
    result?.recruitment_source_types,
    result?.recruitment_source_contacts,
    result?.recruitment_openings,
    result?.recruitment_applications,
  ];

  for (const candidate of candidates) {
    if (Array.isArray(candidate)) return candidate;
    if (Array.isArray(candidate?.data)) return candidate.data;
    if (Array.isArray(candidate?.rows)) return candidate.rows;
  }

  return [];
}

export const ORGANIZATION_ENTITIES_DATAGRID_KEY = "organization_entities_grid";
